import { request } from 'utils/request';
import { header, getUUIDToken } from 'utils/auth';
import {
  getSettingsByType,
  updateSettingsById,
  initializeSettings,
} from 'app/pages/MyautoiqSettingsPage/data/myautoiqSettingsRequestUtils';

const SETTINGS_TYPE = 'TEMPLATE_GENERATION_CONFIG';

const fetchSegmentsForDealerFromAPI = async (
  dealerId: string,
): Promise<any> => {
  try {
    const requestURL = `/api/v1/segments/${dealerId}`;
    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),
    });
    if (!response) throw new Error('Failed to fetch segments');
    return response;
  } catch (error) {
    console.error('Error fetching segments:', error);
    throw error;
  }
};

export const fetchMyautoiqTemplateGenerationSettings = async ({
  manufacturerId,
  makeId,
}: {
  manufacturerId: string;
  makeId?: string | null;
}): Promise<any> => {
  return getSettingsByType({ manufacturerId, makeId, type: SETTINGS_TYPE });
};

export const fetchSegmentsForDealer = async (
  dealerId: string,
): Promise<any> => {
  return fetchSegmentsForDealerFromAPI(dealerId);
};

export const updateMyautoiqTemplateGenerationSettings = async ({
  manufacturerId,
  makeId,
  settingsId,
  data,
}: {
  manufacturerId: string;
  makeId?: string | null;
  settingsId: string;
  data: any;
}): Promise<any> => {
  return updateSettingsById({ manufacturerId, makeId, settingsId, data });
};

export const initializeMyautoiqTemplateGenerationSettings = async ({
  manufacturerId,
  makeId,
}: {
  manufacturerId: string;
  makeId?: string | null;
}): Promise<any> => {
  return initializeSettings({ manufacturerId, makeId, type: SETTINGS_TYPE });
};
